const alert = function (msg) {
  window.alert(msg);
}

const confirm = function (msg) {
  return window.confirm(msg);
}

// const confirm = function (msg) {
//   return window.confirm(msg);
//}

const saveSuccess = function () {
  this.$alert(this.$rs["msg_save_success"]);
}
const sysError = function () {
  this.$alert(this.$rs["msg_system_error"]);
}
const delSuccess = function () {
  this.$alert(this.$rs["msg_del_success"]);
}

const showDateInput = function () {
  var elm = event.srcElement;
  var tmp = elm.getAttribute("class");
  if (tmp && tmp.indexOf("date-input-readonly") === -1 && (this.readOnly == true || this.disabled)) return;

  tmp = this.lan;
  var obj = {};
  obj.lan = tmp;
  obj.el = elm

  tmp = elm.getAttribute("noErrorDeal");
  if (tmp && tmp === "true") {
    obj.errDealMode = -1;
  }
  obj.onpicked = function (dp) {
    elm.focus();
  };
  obj.oncleared = function (dp) {
    $(elm).trigger("keydown");
  };
  WdatePicker(obj);
}

export default {
  alert,
  confirm,
  saveSuccess,
  sysError,
  delSuccess,
  showDateInput
}